module.exports = __webpack_public_path__ + "static/media/ahri-lose.cce0c752.png";